import * as types from "../../constants";
import { ActionsOf, init } from "../utils";
import * as actions from "../actions-declarations/auth"


export type AuthActions = typeof actions;

export type UserType = {
  user?: string;
  token?: string;
};

export type AuthType = {
  user?: UserType | undefined;
};

export default function reducer(
  state = init<{
    user?: {
      user: any,
      token: string;
    }
  }>({} as any),
  actions: ActionsOf<AuthActions>
): typeof state {
  switch (actions.type) {
    case types.AUTH_SIGN_IN_SUCCESS:
      return {
        ...state,
        user: {
          user: actions.user,
          token: actions.token,
        },
      };
    case types.AUTH_SIGN_IN_FAILURE:
      return {
        ...state,
        user: undefined,
      };
    case types.AUTH_SIGN_OUT:
      return {
        ...state,
        user: undefined,
      };

    default:
      return state;
  }
}
